require('./clipCategoryService');

'use strict';

angular.module('app.shared.clipFilter', [
  'app.shared.clipCategoryService'
])
  .filter('clipIsCategoryType', [
    'app.shared.clipCategoryService',
    function (clipCategoryService) {
      return (clipCategory, types) => {
        return clipCategoryService.isType(clipCategory, types);
      };
    }
  ])
  .filter('clipIsCategoryTeam', [
    'app.shared.clipCategoryService',
    function (clipCategoryService) {
      return (clipCategory, team) => {
        return clipCategoryService.isTeam(clipCategory, team);
      }
    }
  ]);



// WEBPACK FOOTER //
// ./app.v2/components/shared/clipFilter.js